import Request from './../request';
import Util from './../util';

import * as log from 'loglevel';

class ProviderGoogle {
    constructor(options) {
        // Default settings
        let defaults = {
            api: '',
            path: '/api/storage',
            queryParams: {}
        };

        // Merge options into defaults
        this.settings = Util.extend(defaults, options || {});
    }

    upload(files, onProgress) {
        const uploadPromises = [];

        const uploadRequests = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            uploadPromises.push(
                new Promise((resolve, reject) => {
                    this._getSignedUrl(file)
                        .then((urls) => {
                            const options = {
                                method: 'PUT',
                                headers: {
                                    // 'x-goog-acl': 'public-read', ACL dont work on read only public permission
                                    'Content-type': file.mimeType
                                },
                                data: file._file // native file obj
                            };

                            // currently only report progress of original file ( enough for now ! )
                            // TODO here we probably would need to calc total and show progress of all
                            if (i === 0) {
                                options.onProgress = onProgress;
                            }

                            const request = new Request(urls.upload, options);

                            uploadRequests.push(request);

                            request
                                .then((response) => {
                                    // set download infos
                                    file.url = urls.download;
                                    file.path = urls.path;

                                    // NEW: get the actual uploaded file size from cloud storage (requires cors config to allow access to this header)
                                    let contentLength = parseInt(response.xhr.getResponseHeader('x-goog-stored-content-length'));
                                    if(!isNaN(contentLength)){
                                        // we store it on meta to pass it trough the final saved file
                                        if(file.meta){
                                            file.meta.contentLength = contentLength;
                                        }
                                    }
                                    // return file obj
                                    resolve(file);
                                })
                                .catch((error) => {
                                    reject(error);
                                });
                        })
                        .catch((error) => {
                            // Do something for an error here
                            reject(error);
                        });
                })
            );
        }

        // wait for all uploads to finish
        let all = Promise.all(uploadPromises).then((files) => {
            log.info(files);

            return files;
        });

        all.cancel = () => {
            // cancel all requests
            for (let i = 0; i < uploadRequests.length; i++) {
                const uploadRequest = uploadRequests[i];
                uploadRequest.cancel();
            }
        };

        return all;
    }

    _getSignedUrl(file) {
        let url = this.settings.api + this.settings.path;

        let params = Util.extend(this.settings.queryParams, {
            name: encodeURIComponent(file.name),
            type: encodeURIComponent(file.mimeType),
            public: '1', // public used for cache control in cloud storage ( all uploads are public )
            // add random number * multiply to avoid float - timestamp was not sufficient
            cb: (Math.random() * 1000000000000000000) + "", // to avoid browser caching ( was cached by safari when the file.name was equal for original and thumbnail .. )
        });

        let request = new Request(url, {
            method: 'GET',
            queryParams: params
        });

        return request.then((response) => {
            return response.data;
        });
    }
}

export default ProviderGoogle;
